<div class="modal-overlay" *ngIf="show">
  <ng-container *ngIf="variante === 'solicitud'; else modalEstandar">
    <div class="modal-card modal-card--solicitud">
      <div class="modal-card__header-solicitud">
        <button class="modal-card__close" type="button" (click)="cerrar()" aria-label="Cerrar">
          <i class="fas fa-times"></i>
        </button>
        <div class="modal-card__icon modal-card__icon--solicitud">
          <i class="fas fa-check-circle"></i>
        </div>
        <h2 class="modal-card__title modal-card__title--solicitud">{{ titulo }}</h2>
      </div>
      <div class="modal-card__body modal-card__body--solicitud">
        <div class="modal-card__message modal-card__message--solicitud" [innerHTML]="mensaje"></div>
      </div>
      <div class="modal-card__footer-solicitud">
        <button *ngIf="mostrarBoton" class="modal-card__btn modal-card__btn--solicitud" type="button" (click)="confirmar()">
          {{ textoBoton }}
        </button>
      </div>
    </div>
  </ng-container>

  <ng-template #modalEstandar>
    <div class="modal-card" [ngClass]="'modal-card--' + tipo" [style.maxWidth]="ancho || null">
      <div class="modal-card__accent"></div>
      <div class="modal-card__body">
        <div class="modal-card__icon" [ngClass]="'modal-card__icon--' + tipo">
          <i [class]="iconoPorTipo(tipo)"></i>
        </div>
        <h2 class="modal-card__title">{{ titulo }}</h2>
        <p class="modal-card__message" [innerHTML]="mensaje"></p>
        <div class="modal-card__extra">
          <ng-content></ng-content>
        </div>
        <div class="modal-card__actions">
          <button *ngIf="textoBotonCancelar" class="modal-card__btn modal-card__btn--cancel" type="button" (click)="cerrar()">
            {{ textoBotonCancelar }}
          </button>
          <button *ngIf="mostrarBoton" class="modal-card__btn" type="button" (click)="confirmar()">
            {{ textoBoton }}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</div>
